import * as types from '../constants/archivedetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  archivedetails: null,
  archivedetailsList: null,
  switcharchivedetailsList: null
}

export function archiveDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ARCHIVE_REQUEST:
      return {
        ...state,
        Status: true
      };
    case types.FETCH_ARCHIVE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        archivedetails: action.data
      };
    case types.FETCH_ARCHIVE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // archivedetailsList:action.error
      };
    case types.FETCH_ARCHIVE_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        // archivedetails: null,
      };
    case types.FETCH_ARCHIVE_LIST_REQUEST:
      return {
        ...state,
        Status: true
      };
    case types.FETCH_ARCHIVE_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        archivedetailsList: action.data
      };
    case types.FETCH_ARCHIVE_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // archivedetailsList:action.error
      };
    case types.FETCH_SWITCH_ARCHIVE_LIST_REQUEST:
      return {
        ...state,
        Status: true
      };
    case types.FETCH_SWITCH_ARCHIVE_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        switcharchivedetailsList: action.data
      };
    case types.FETCH_SWITCH_ARCHIVE_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false
      };
    case types.ADD_ARCHIVE_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_ARCHIVE_REQUEST:
      return {
        ...state,
        Status: true
      };
    case types.ADD_ARCHIVE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_ARCHIVE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/archivedetails.js